export interface Pays {
  nom: string;
  alpha2: string;
}

export const paysList: Pays[] = [
  {"nom": "France", "alpha2": "FR"},
  {"nom": "Afghanistan", "alpha2": "AF"},
  {"nom": "Afrique du Sud", "alpha2": "ZA"},
  {"nom": "Albanie", "alpha2": "AL"},
  {"nom": "Algérie", "alpha2": "DZ"},
  {"nom": "Allemagne", "alpha2": "DE"},
  {"nom": "Andorre", "alpha2": "AD"},
  {"nom": "Angola", "alpha2": "AO"},
  {"nom": "Anguilla", "alpha2": "AI"},
  {"nom": "Antarctique", "alpha2": "AQ"},
  {"nom": "Antigua-et-Barbuda", "alpha2": "AG"},
  {"nom": "Arabie saoudite", "alpha2": "SA"},
  {"nom": "Argentine", "alpha2": "AR"},
  {"nom": "Arménie", "alpha2": "AM"},
  {"nom": "Aruba", "alpha2": "AW"},
  {"nom": "Australie", "alpha2": "AU"},
  {"nom": "Autriche", "alpha2": "AT"},
  {"nom": "Azerbaïdjan", "alpha2": "AZ"},
  {"nom": "Bahamas", "alpha2": "BS"},
  {"nom": "Bahreïn", "alpha2": "BH"},
  {"nom": "Bangladesh", "alpha2": "BD"},
  {"nom": "Barbade", "alpha2": "BB"},
  {"nom": "Bélarus", "alpha2": "BY"},
  {"nom": "Belgique", "alpha2": "BE"},
  {"nom": "Belize", "alpha2": "BZ"},
  {"nom": "Bénin", "alpha2": "BJ"},
  {"nom": "Bermudes", "alpha2": "BM"},
  {"nom": "Bhoutan", "alpha2": "BT"},
  {"nom": "Bolivie", "alpha2": "BO"},
  {"nom": "Bonaire, Saint-Eustache et Saba", "alpha2": "BQ"},
  {"nom": "Bosnie-Herzégovine", "alpha2": "BA"},
  {"nom": "Botswana", "alpha2": "BW"},
  {"nom": "Bouvet (Île)", "alpha2": "BV"},
  {"nom": "Brésil", "alpha2": "BR"},
  {"nom": "Brunéi Darussalam", "alpha2": "BN"},
  {"nom": "Bulgarie", "alpha2": "BG"},
  {"nom": "Burkina Faso", "alpha2": "BF"},
  {"nom": "Burundi", "alpha2": "BI"},
  {"nom": "Cabo Verde", "alpha2": "CV"},
  {"nom": "Cambodge", "alpha2": "KH"},
  {"nom": "Cameroun", "alpha2": "CM"},
  {"nom": "Canada", "alpha2": "CA"},
  {"nom": "Chili", "alpha2": "CL"},
  {"nom": "Chine", "alpha2": "CN"},
  {"nom": "Chypre", "alpha2": "CY"},
  {"nom": "Colombie", "alpha2": "CO"},
  {"nom": "Comores", "alpha2": "KM"},
  {"nom": "Congo", "alpha2": "CG"},
  {"nom": "Congo (République démocratique du)", "alpha2": "CD"},
  {"nom": "Corée du Nord", "alpha2": "KP"},
  {"nom": "Corée du Sud", "alpha2": "KR"},
  {"nom": "Costa Rica", "alpha2": "CR"},
  {"nom": "Côte d’Ivoire", "alpha2": "CI"},
  {"nom": "Croatie", "alpha2": "HR"},
  {"nom": "Cuba", "alpha2": "CU"},
  {"nom": "Curaçao", "alpha2": "CW"},
  {"nom": "Danemark", "alpha2": "DK"},
  {"nom": "Djibouti", "alpha2": "DJ"},
  {"nom": "Dominique", "alpha2": "DM"},
  {"nom": "Égypte", "alpha2": "EG"},
  {"nom": "El Salvador", "alpha2": "SV"},
  {"nom": "Émirats arabes unis", "alpha2": "AE"},
  {"nom": "Équateur", "alpha2": "EC"},
  {"nom": "Érythrée", "alpha2": "ER"},
  {"nom": "Espagne", "alpha2": "ES"},
  {"nom": "Estonie", "alpha2": "EE"},
  {"nom": "Eswatini", "alpha2": "SZ"},
  {"nom": "États-Unis", "alpha2": "US"},
  {"nom": "Éthiopie", "alpha2": "ET"},
  {"nom": "Fidji", "alpha2": "FJ"},
  {"nom": "Finlande", "alpha2": "FI"},
  {"nom": "Gabon", "alpha2": "GA"},
  {"nom": "Gambie", "alpha2": "GM"},
  {"nom": "Géorgie", "alpha2": "GE"},
  {"nom": "Ghana", "alpha2": "GH"},
  {"nom": "Gibraltar", "alpha2": "GI"},
  {"nom": "Grèce", "alpha2": "GR"},
  {"nom": "Grenade", "alpha2": "GD"},
  {"nom": "Groenland", "alpha2": "GL"},
  {"nom": "Guadeloupe", "alpha2": "GP"},
  {"nom": "Guam", "alpha2": "GU"},
  {"nom": "Guatemala", "alpha2": "GT"},
  {"nom": "Guernesey", "alpha2": "GG"},
  {"nom": "Guinée", "alpha2": "GN"},
  {"nom": "Guinée-Bissau", "alpha2": "GW"},
  {"nom": "Guinée équatoriale", "alpha2": "GQ"},
  {"nom": "Guyana", "alpha2": "GY"},
  {"nom": "Guyane française", "alpha2": "GF"},
  {"nom": "Haïti", "alpha2": "HT"},
  {"nom": "Honduras", "alpha2": "HN"},
  {"nom": "Hong Kong", "alpha2": "HK"},
  {"nom": "Hongrie", "alpha2": "HU"},
  {"nom": "Île Christmas", "alpha2": "CX"},
  {"nom": "Île de Man", "alpha2": "IM"},
  {"nom": "Île Norfolk", "alpha2": "NF"},
  {"nom": "Îles Caïmans", "alpha2": "KY"},
  {"nom": "Îles Cocos", "alpha2": "CC"},
  {"nom": "Îles Cook", "alpha2": "CK"},
  {"nom": "Îles Féroé", "alpha2": "FO"},
  {"nom": "Îles Malouines", "alpha2": "FK"},
  {"nom": "Îles Mariannes du Nord", "alpha2": "MP"},
  {"nom": "Îles Marshall", "alpha2": "MH"},
  {"nom": "Îles Pitcairn", "alpha2": "PN"},
  {"nom": "Îles Salomon", "alpha2": "SB"},
  {"nom": "Îles Turques-et-Caïques", "alpha2": "TC"},
  {"nom": "Îles Vierges britanniques", "alpha2": "VG"},
  {"nom": "Îles Vierges des États-Unis", "alpha2": "VI"},
  {"nom": "Inde", "alpha2": "IN"},
  {"nom": "Indonésie", "alpha2": "ID"},
  {"nom": "Iran", "alpha2": "IR"},
  {"nom": "Iraq", "alpha2": "IQ"},
  {"nom": "Irlande", "alpha2": "IE"},
  {"nom": "Islande", "alpha2": "IS"},
  {"nom": "Israël", "alpha2": "IL"},
  {"nom": "Italie", "alpha2": "IT"},
  {"nom": "Jamaïque", "alpha2": "JM"},
  {"nom": "Japon", "alpha2": "JP"},
  {"nom": "Jersey", "alpha2": "JE"},
  {"nom": "Jordanie", "alpha2": "JO"},
  {"nom": "Kazakhstan", "alpha2": "KZ"},
  {"nom": "Kenya", "alpha2": "KE"},
  {"nom": "Kirghizistan", "alpha2": "KG"},
  {"nom": "Kiribati", "alpha2": "KI"},
  {"nom": "Koweït", "alpha2": "KW"},
  {"nom": "Laos", "alpha2": "LA"},
  {"nom": "Lesotho", "alpha2": "LS"},
  {"nom": "Lettonie", "alpha2": "LV"},
  {"nom": "Liban", "alpha2": "LB"},
  {"nom": "Liberia", "alpha2": "LR"},
  {"nom": "Libye", "alpha2": "LY"},
  {"nom": "Liechtenstein", "alpha2": "LI"},
  {"nom": "Lituanie", "alpha2": "LT"},
  {"nom": "Luxembourg", "alpha2": "LU"},
  {"nom": "Macao", "alpha2": "MO"},
  {"nom": "Macédoine du Nord", "alpha2": "MK"},
  {"nom": "Madagascar", "alpha2": "MG"},
  {"nom": "Malaisie", "alpha2": "MY"},
  {"nom": "Malawi", "alpha2": "MW"},
  {"nom": "Maldives", "alpha2": "MV"},
  {"nom": "Mali", "alpha2": "ML"},
  {"nom": "Malte", "alpha2": "MT"},
  {"nom": "Maroc", "alpha2": "MA"},
  {"nom": "Martinique", "alpha2": "MQ"},
  {"nom": "Maurice", "alpha2": "MU"},
  {"nom": "Mauritanie", "alpha2": "MR"},
  {"nom": "Mayotte", "alpha2": "YT"},
  {"nom": "Mexique", "alpha2": "MX"},
  {"nom": "Micronésie", "alpha2": "FM"},
  {"nom": "Moldavie", "alpha2": "MD"},
  {"nom": "Monaco", "alpha2": "MC"},
  {"nom": "Mongolie", "alpha2": "MN"},
  {"nom": "Monténégro", "alpha2": "ME"},
  {"nom": "Montserrat", "alpha2": "MS"},
  {"nom": "Mozambique", "alpha2": "MZ"},
  {"nom": "Myanmar", "alpha2": "MM"},
  {"nom": "Namibie", "alpha2": "NA"},
  {"nom": "Nauru", "alpha2": "NR"},
  {"nom": "Népal", "alpha2": "NP"},
  {"nom": "Nicaragua", "alpha2": "NI"},
  {"nom": "Niger", "alpha2": "NE"},
  {"nom": "Nigéria", "alpha2": "NG"},
  {"nom": "Niue", "alpha2": "NU"},
  {"nom": "Norvège", "alpha2": "NO"},
  {"nom": "Nouvelle-Calédonie", "alpha2": "NC"},
  {"nom": "Nouvelle-Zélande", "alpha2": "NZ"},
  {"nom": "Oman", "alpha2": "OM"},
  {"nom": "Ouganda", "alpha2": "UG"},
  {"nom": "Ouzbékistan", "alpha2": "UZ"},
  {"nom": "Pakistan", "alpha2": "PK"},
  {"nom": "Palaos", "alpha2": "PW"},
  {"nom": "Panama", "alpha2": "PA"},
  {"nom": "Papouasie-Nouvelle-Guinée", "alpha2": "PG"},
  {"nom": "Paraguay", "alpha2": "PY"},
  {"nom": "Pays-Bas", "alpha2": "NL"},
  {"nom": "Pérou", "alpha2": "PE"},
  {"nom": "Philippines", "alpha2": "PH"},
  {"nom": "Pologne", "alpha2": "PL"},
  {"nom": "Polynésie française", "alpha2": "PF"},
  {"nom": "Porto Rico", "alpha2": "PR"},
  {"nom": "Portugal", "alpha2": "PT"},
  {"nom": "Qatar", "alpha2": "QA"},
  {"nom": "République centrafricaine", "alpha2": "CF"},
  {"nom": "République tchèque", "alpha2": "CZ"},
  {"nom": "Réunion", "alpha2": "RE"},
  {"nom": "Roumanie", "alpha2": "RO"},
  {"nom": "Royaume-Uni", "alpha2": "GB"},
  {"nom": "Russie", "alpha2": "RU"},
  {"nom": "Rwanda", "alpha2": "RW"},
  {"nom": "Sahara occidental", "alpha2": "EH"},
  {"nom": "Saint-Barthélemy", "alpha2": "BL"},
  {"nom": "Saint-Christophe-et-Niévès", "alpha2": "KN"},
  {"nom": "Saint-Marin", "alpha2": "SM"},
  {"nom": "Saint-Martin", "alpha2": "MF"},
  {"nom": "Saint-Pierre-et-Miquelon", "alpha2": "PM"},
  {"nom": "Saint-Vincent-et-les-Grenadines", "alpha2": "VC"},
  {"nom": "Sainte-Lucie", "alpha2": "LC"},
  {"nom": "Salvador", "alpha2": "SV"},
  {"nom": "Samoa", "alpha2": "WS"},
  {"nom": "Sao Tomé-et-Principe", "alpha2": "ST"},
  {"nom": "Sénégal", "alpha2": "SN"},
  {"nom": "Serbie", "alpha2": "RS"},
  {"nom": "Seychelles", "alpha2": "SC"},
  {"nom": "Sierra Leone", "alpha2": "SL"},
  {"nom": "Singapour", "alpha2": "SG"},
  {"nom": "Slovaquie", "alpha2": "SK"},
  {"nom": "Slovénie", "alpha2": "SI"},
  {"nom": "Somalie", "alpha2": "SO"},
  {"nom": "Soudan", "alpha2": "SD"},
  {"nom": "Soudan du Sud", "alpha2": "SS"},
  {"nom": "Sri Lanka", "alpha2": "LK"},
  {"nom": "Suède", "alpha2": "SE"},
  {"nom": "Suisse", "alpha2": "CH"},
  {"nom": "Suriname", "alpha2": "SR"},
  {"nom": "Syrie", "alpha2": "SY"},
  {"nom": "Tadjikistan", "alpha2": "TJ"},
  {"nom": "Taïwan", "alpha2": "TW"},
  {"nom": "Tanzanie", "alpha2": "TZ"},
  {"nom": "Tchad", "alpha2": "TD"},
  {"nom": "Thaïlande", "alpha2": "TH"},
  {"nom": "Timor-Leste", "alpha2": "TL"},
  {"nom": "Togo", "alpha2": "TG"},
  {"nom": "Tokelau", "alpha2": "TK"},
  {"nom": "Tonga", "alpha2": "TO"},
  {"nom": "Trinité-et-Tobago", "alpha2": "TT"},
  {"nom": "Tunisie", "alpha2": "TN"},
  {"nom": "Turkménistan", "alpha2": "TM"},
  {"nom": "Turquie", "alpha2": "TR"},
  {"nom": "Tuvalu", "alpha2": "TV"},
  {"nom": "Ukraine", "alpha2": "UA"},
  {"nom": "Uruguay", "alpha2": "UY"},
  {"nom": "Vanuatu", "alpha2": "VU"},
  {"nom": "Vatican", "alpha2": "VA"},
  {"nom": "Venezuela", "alpha2": "VE"},
  {"nom": "Viêt Nam", "alpha2": "VN"},
  {"nom": "Wallis-et-Futuna", "alpha2": "WF"},
  {"nom": "Yémen", "alpha2": "YE"},
  {"nom": "Zambie", "alpha2": "ZM"},
  {"nom": "Zimbabwe", "alpha2": "ZW"}
]
